(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["albavelle-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.AlbavelleReveal) return;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function revealAll() {
    document.querySelectorAll('[data-av-reveal], [data-av-reveal-media]').forEach(function (el) {
      el.classList.add('is-visible');
    });
    document.querySelectorAll('[data-av-line]').forEach(function (el) {
      el.classList.add('is-drawn');
    });
  }

  if (reduceMotion || !('IntersectionObserver' in window)) {
    revealAll();
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var delay = parseInt(el.getAttribute('data-av-delay') || '0', 10);
        window.setTimeout(function () {
          el.classList.add('is-visible');
          if (el.hasAttribute('data-av-line')) el.classList.add('is-drawn');
        }, delay);
        io.unobserve(el);
      });
    }, { threshold: 0.2, rootMargin: '0px 0px -8% 0px' });

    document.querySelectorAll('[data-av-reveal], [data-av-reveal-media], [data-av-line]').forEach(function (el) {
      io.observe(el);
    });
  }

  window.AlbavelleReveal = { revealAll: revealAll };

  document.querySelectorAll('[data-av-hero] [data-av-reveal], [data-av-hero] [data-av-reveal-media]').forEach(function (el) {
    var delay = parseInt(el.getAttribute('data-av-delay') || '0', 10);
    window.setTimeout(function () { el.classList.add('is-visible'); }, delay + 60);
  });
  document.querySelectorAll('[data-av-hero] [data-av-line]').forEach(function (el) {
    window.setTimeout(function () { el.classList.add('is-drawn'); }, 420);
  });

  if (!reduceMotion) {
    var cue = document.querySelector('[data-av-scroll-cue]');
    if (cue) {
      cue.addEventListener('click', function () {
        var next = document.querySelector('[data-av-hero]').nextElementSibling;
        if (next) next.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    var media = document.querySelector('[data-av-reveal-media]');
    if (media) {
      var ticking = false;
      window.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          var rect = media.getBoundingClientRect();
          var offset = (rect.top) * 0.06;
          media.style.transform = 'translateY(' + offset.toFixed(1) + 'px)';
          ticking = false;
        });
      }, { passive: true });
    }
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
